<!-- Cart -->
<!--
  TICKET DETAILS card: literal card
  border/radius, blue/gray/light-blue accents on the breakdown grid, and a
  two-tone total line. Style/layout only — same bindings/copy/data-cy hooks
  as before; the copy stays "Your Ticket Details".
-->
<div
  id="ticket-details"
  class="md:flex md:flex-col md:justify-between bg-white p-4 border border-[#F2F2F2] rounded-3xl w-full h-fit">
  <div>
    <div class="flex items-center px-2 md:px-4 pt-2 pb-4">
      <div class="w-full md:text-left text-center">
        <!--
          Brand colour, not a hardcoded blue:
          `text-main` resolves to `rgb(var(--default-color))`, the club's own
          primary colour, so every tenant gets its own theme here instead of
          all clubs sharing one fixed placeholder blue.
        -->
        <h3 class="mb-1 font-extrabold text-main text-xl">
          Your Ticket Details
        </h3>
      </div>
    </div>
    <div class="md:m-2 px-2 md:px-4 py-2">
      <div class="md:px-4 w-full">
        <table class="w-full border-separate table-fixed">
          @for (section of seatsForTable(); track section.id) {
            <tr class="flex flex-wrap md:flex-nowrap my-2 mb-3 md:mb-0">
              <td class="content-center mb-1 md:mb-0 w-full md:w-16 td">
                <div class="flex justify-center items-center">
                  <img
                    ngSrc="/assets/img/chair-blue-icon.svg"
                    alt="main chair icon"
                    width="12"
                    height="12"
                    [priority]="false"
                    class="mr-1" />
                  <p class="font-bold text-main text-center">
                    {{ section.totalSectionSeats }}
                  </p>
                </div>
              </td>
              <td
                class="flex justify-center md:mx-2 mb-1 md:mb-0 w-full md:w-28 td">
                <p class="flex items-center text-center">
                  Section
                  <span class="ml-2 font-bold text-main">{{ section.id }}</span>
                </p>
              </td>
              <td class="p-0 w-full">
                @for (row of section.rows; track row.id) {
                  <div
                    class="flex flex-wrap md:flex-nowrap gap-2 mb-1 last:mb-0">
                    <p class="flex items-center td-row">
                      Row<span class="ml-2 font-bold text-main">{{
                        row.id
                      }}</span>
                    </p>
                    <p class="flex flex-1 items-center td-seats">
                      Seats<span class="ml-2 font-bold text-main">{{
                        row.seatsRanges.join(', ')
                      }}</span>
                    </p>
                  </div>
                }
              </td>
            </tr>
          }
        </table>
      </div>
      <!--
        Per-price-group lines, listed below the
        section/row/seats grid (subtotals after the seat breakdown).
        A "+ fees per ticket $X" suffix is intentionally NOT rendered —
        there is no per-ticket fee binding on this component today.
      -->
      <div class="md:px-8 mt-4">
        @for (seat of seatsByPrice(); track $index) {
          <h4 class="font-bold md:text-left text-center">
            <span data-cy="cart-seats-quantity" class="text-main">{{
              seat.quantity
            }}</span>
            Seats x
            <span data-cy="cart-buyer-type">{{
              transaction().transaction.buyerTypeName
            }}</span>
            at
            <span class="text-main">${{ seat.price | number: '1.2-2' }}</span>
          </h4>
        }
      </div>
    </div>
  </div>
  <div class="flex justify-end items-center p-5 border-t border-t-gray-100">
    @if (transaction().transaction.tdcTransaction?.totalPriceSeats) {
      <h5 class="flex items-baseline gap-1 font-bold">
        <span class="text-xs">Total Price:</span>
        <span class="text-main text-base">
          ${{
            transaction().transaction.tdcTransaction?.totalPriceSeats
              | number: '1.2-2'
          }}
        </span>
      </h5>
    }
  </div>
</div>
